import { useSelectedClient } from '@entities/clients/heplers.ts';
import { useNavigate, useParams } from 'react-router-dom';
import { useClientNoteEditPageRedirect } from '@pages/clients/note/helpers.ts';
import { useClientContactModal } from '@widgets/clients/client_contact_modal/helpers.ts';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import { clientActions } from '@src/entities/clients/model';
import { useModules, type AppModule } from '@src/entities/common';

export const useTabs = (clientId?: number) => {
  const { modules } = useModules();

  const { tabCode } = useParams();
  const { redirectOnEditNote } = useClientNoteEditPageRedirect();
  const dispatch = useAppDispatch();
  const selectedModule = useAppSelector((store) => store.clients.client.selectedModule);
  const selectedTab = useAppSelector((store) => store.clients.client.selectedTab);
  const { openClientContactModal } = useClientContactModal();

  const isShowingActiveTabOnMobile = useAppSelector(
    (store) => store.clients.client.isShowingActiveTabOnMobile
  );

  // нужно выводить именно в таком порядке 'schedule', 'programs', 'events'
  const clientModuleTypes = ['schedule', 'programs', 'events', 'articles'];

  const clientModules: AppModule[] = [];

  clientModuleTypes.map((clientModuleType) => {
    modules.filter((mod) => {
      if (
        mod.module_type === clientModuleType &&
        !(mod.module_type === 'programs' && mod.code !== 'library')
      )
        clientModules.push(mod);
    });
  });

  const onTabChange = (tab: string, module?: AppModule) => {
    dispatch(clientActions.changeTab({ tab, module }));
  };

  const onCloseOnMobile = () => {
    dispatch(clientActions.closeTabOnMobile());
  };

  const navigate = useNavigate();
  const { selectedClient } = useSelectedClient();
  // const { selectedClient, selectedClientData } = useClients();

  const toggleActionModal = () => {
    // if (selectedTab === 'notes') navigate(`${selectedClientData?.user.id}/notes/new`);
    if (selectedTab === 'contacts' || tabCode === 'contacts') {
      openClientContactModal({
        type: 'create',
        clientId,
      });
    }
    if (selectedTab === 'notes' || tabCode === 'notes') {
      redirectOnEditNote(`note/edit/new`, {
        state: { path: window.location.pathname, client: selectedClient },
      });
    }
    if (selectedTab === 'programs' || tabCode === 'programs')
      navigate(`${selectedClient.id}/${selectedModule?.code}/recommend`);

    if (selectedTab === 'schedule' || tabCode === 'schedules')
      navigate(`${selectedClient.id}/${selectedModule?.code}/assign`);
    if (selectedTab === 'events') navigate(`/events/${selectedModule?.code}`);
    if (selectedTab === 'groups' || tabCode === 'groups')
      navigate(`/clients/groups/edit/new`, { state: { path: window.location.pathname } });
  };

  const actionTitle: { [x: string]: string } = {
    notes: 'Новая заметка',
    programs: 'Рекомендовать',
    schedule: 'Записать',
    events: 'Участвовать',
  };

  return {
    selectedTab,
    selectedModule,
    selectedClient,
    clientModules,
    onTabChange,
    toggleActionModal,
    onCloseOnMobile,
    actionTitle,
    isShowingActiveTabOnMobile,
  };
};
